module.exports = __webpack_public_path__ + "static/media/Car_calligraphy_main_p.055e5e89.jpg";